import React from 'react';
import {
  Box,
  Paper,
  Typography,
  useTheme,
  alpha,
  Skeleton,
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const DurationStatsPanel = ({ durationStats, isLoading, hasData }) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        bgcolor: 'background.paper',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <AccessTimeIcon sx={{ color: 'info.main', fontSize: 24 }} />
        <Typography variant="h6" fontWeight={600}>
          Duration Stats
        </Typography>
      </Box>

      {hasData && !isLoading ? (
        <Box sx={{ display: 'flex', gap: 2, flex: 1 }}>
          <Box
            sx={{
              flex: 1,
              p: 2,
              borderRadius: 2,
              bgcolor: alpha(theme.palette.info.main, 0.08),
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Total Time
            </Typography>
            <Typography variant="h5" fontWeight={700} color="info.main">
              {durationStats?.totalHours || 0}h {durationStats?.totalMinutes || 0}m
            </Typography>
          </Box>

          <Box
            sx={{
              flex: 1,
              p: 2,
              borderRadius: 2,
              bgcolor: alpha(theme.palette.warning.main, 0.08),
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Avg Patrol Length
            </Typography>
            <Typography variant="h5" fontWeight={700} color="warning.main">
              {durationStats?.avgPatrolLength || 0} min
            </Typography>
          </Box>

          <Box
            sx={{
              flex: 1,
              p: 2,
              borderRadius: 2,
              bgcolor: alpha(theme.palette.success.main, 0.08),
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
              <TrendingUpIcon sx={{ color: 'success.main', fontSize: 18 }} />
              <Typography variant="body2" color="text.secondary">
                Patrols/Day
              </Typography>
            </Box>
            <Typography variant="h5" fontWeight={700} color="success.main">
              {durationStats?.avgPatrolsPerDay || 0}
            </Typography>
          </Box>
        </Box>
      ) : isLoading ? (
        <Box sx={{ display: 'flex', gap: 2, flex: 1 }}>
          <Skeleton variant="rounded" sx={{ flex: 1, height: 80 }} />
          <Skeleton variant="rounded" sx={{ flex: 1, height: 80 }} />
          <Skeleton variant="rounded" sx={{ flex: 1, height: 80 }} />
        </Box>
      ) : (
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            Search to view duration stats
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default DurationStatsPanel;
